import { render, staticRenderFns } from "./PageHomepage.vue?vue&type=template&id=2bf0a0d4&"
import script from "./PageHomepage.js?vue&type=script&lang=js&"
export * from "./PageHomepage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports